import React from 'react'

import HeroImage from '../assets/hero.svg'

type CollegeHeroSectionPropsTypes = {
  children?: React.ReactNode
}

const CollegeHeroSection = ({ children }: CollegeHeroSectionPropsTypes) => {
  return (
    <section className="bg-gray-200 text-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-24 py-12 w-full">
        <div className="flex justify-between items-center">
          <div>
            <div className="space-y-5 mb-10">
              <h3 className="text-3xl xs:text-2xl md:text-4xl font-semibold tracking-tight">
                India&apos;s Top Computer Science Undergrad <br /> Programme to
                get{' '}
                <span
                  style={{
                    textDecoration: 'underline',
                    textDecorationColor: '#8080FF',
                    textDecorationThickness: '10px',
                    textDecorationSkipInk: 'none',
                    textUnderlineOffset: '-40%',
                    textUnderlinePosition: 'under'
                  }}>
                  YOU the Best Tech Job
                </span>
              </h3>
              <ul className="list-disc ml-4 sm:mx-10 max-w-2xl text-base md:text-lg space-y-5">
                <li>
                  Learn with Industry experts from Google, Microsoft, Amazon,
                  Hackerrank, etc
                </li>
                <li>
                  Paid Internships after 1st year with stipends upto 50K per
                  month
                </li>
                <li>
                  Startup or choose your own domain (AI/System Design) in last 6
                  months
                </li>
              </ul>

              {/* <p className="text-base md:text-lg lg:text-xl">
                Application Deadline:{' '}
                <span className="font-semibold">10th August</span>
              </p> */}
              <p className="text-base md:text-lg lg:text-xl">
                Application Deadline for Batch2:{' '}
                <span className="font-semibold"> Application Closed</span>
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-6">{children}</div>
          </div>
          <div className="hidden md:block w-[550px] h-full">
            <img className="w-full h-full" src={HeroImage.src} alt="" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default CollegeHeroSection
